import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { getAccAccount, resetAccAccountState } from "../../../store/accAccount/action";

//Import actions
import { getTransactionTax as onGetTransactionTaxs, addNewTransactionTax as onAddNewTransactionTax, updateTransactionTax as onUpdateTransactionTax, deleteTransactionTax as onDeleteTransactionTax, getTransactionTaxLoading, resetTransactionTaxState } from "../../../store/transactionTax/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../Components/Common/ExportDoc";

const TransactionTax = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [pageIdx, setPageIdx] = useState(0);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clientLoading, clients, companies, companyLoading, transactionTaxs, isTransactionTaxCreated, isTransactionTaxSuccess, loading, error, accAccounts, accAccountLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    transactionTaxs: state.TransactionTax.transactionTaxs,
    isTransactionTaxCreated: state.TransactionTax.isTransactionTaxCreated,
    isTransactionTaxSuccess: state.TransactionTax.isTransactionTaxSuccess,
    loading: state.TransactionTax.loading,
    error: state.TransactionTax.error,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    accAccounts: state.AccAccount.accAccounts,
    accAccountLoading: state.AccAccount.loading,
  }));

  const [transactionTaxList, setTransactionTaxList] = useState([]);
  const [transactionTaxDoc, setTransactionTaxDoc] = useState([]);
  const [transactionTax, setTransactionTax] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [accountingList, setAccountingList] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const onClickDelete = (transactionTax) => {
    setTransactionTax(transactionTax);
    setDeleteModal(true);
  };

  const handleDeleteTransactionTax = () => {
    if (transactionTax) {
      dispatch(onDeleteTransactionTax(transactionTax));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    if (!isEmpty(transactionTaxs)) {
      let filteredTransactionTaxs = transactionTaxs;
      if (activeTypeTab !== "all") {
        filteredTransactionTaxs = transactionTaxs.filter((transactionTax) => transactionTax.transaction_tax_status.name === activeTypeTab);
      }
      setTransactionTaxList(filteredTransactionTaxs.map((el) => ({ ...el, isChecked: false })));
    }
  }, [transactionTaxs]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "name",
        label: "Nama",
        isSelected: true,
        data: [],
      },
      {
        id: "code",
        label: "Kode",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Pajak",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_tax_acc_account",
        label: "Akun Pajak",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_tax_client",
        label: "Grup Usaha",
        isSelected: true,
        data: [],
      },
      {
        id: "transaction_tax_company",
        label: "Perusahaan",
        isSelected: true,
        data: [],
      },
    ];

    if (transactionTaxList.length > 0) {
      transactionTaxList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "transaction_tax_client" || doc.id === "transaction_tax_company" || doc.id === "transaction_tax_acc_account") {
                doc.data.push(value?.name ?? "");
              } else {
                doc.data.push(value ?? "-");
              }
            }
          });
        }
      });
    }

    setTransactionTaxDoc(dataDoc);
  }, [transactionTaxList]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredTransactionTaxs = transactionTaxs;
      if (type !== "all") {
        filteredTransactionTaxs = transactionTaxs.filter((transactionTax) => transactionTax.transaction_tax_status.name === type);
      }
      setTransactionTaxList(filteredTransactionTaxs);
    }
  };

  useEffect(() => {
    dispatch(resetTransactionTaxState());
    dispatch(onGetTransactionTaxs());
    handleGetAccAccount(companySelected?.value);
  }, [companySelected]);

  const handleGetAccAccount = (companyId) => {
    dispatch(resetAccAccountState());
    dispatch(getAccAccount({ companyId: companyId, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(accAccounts)) {
      var data = [];
      var opt = [];
      accAccounts.forEach((item, key) => {
        const name = item.name;
        const code = item.code;
        const id = item.id;
        var obj = { label: code + " " + name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setAccountingList(data);
    }
  }, [accAccounts]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  // useEffect(() => {
  //   if (!isEmpty(transactionTaxs)) {
  //     setTransactionTax(transactionTaxs);
  //     setTransactionTaxList(transactionTaxs);
  //     setIsEdit(false);
  //   }
  // }, [transactionTaxs]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setTransactionTax(null);
      setCompanyList([]);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleTransactionTaxClick = useCallback(
    (arg) => {
      const transactionTax = arg;
      setTransactionTax({
        id: transactionTax.id,
        name: transactionTax.name,
        amount: transactionTax.amount,
        description: transactionTax.description,
        account: transactionTax.transaction_tax_acc_account && {
          label: transactionTax.transaction_tax_acc_account.name,
          value: transactionTax.transaction_tax_acc_account.id,
        },
        company: transactionTax.transaction_tax_company && {
          label: transactionTax.transaction_tax_company.name,
          value: transactionTax.transaction_tax_company.id,
        },
        client: transactionTax.asset_class_client && {
          label: transactionTax.transaction_tax_client.name,
          value: transactionTax.transaction_tax_client.id,
        },
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, userType]
  );

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      client: (transactionTax && transactionTax.client) || clientSelected,
      company: (transactionTax && transactionTax.company) || companySelected,
      account: (transactionTax && transactionTax.account) ?? "",
      name: (transactionTax && transactionTax.name) ?? "",
      code: (transactionTax && transactionTax.code) ?? "",
      amount: (transactionTax && transactionTax.amount) || 0,
      description: (transactionTax && transactionTax.description) ?? "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter transaction name"),
      amount: Yup.string().required("Please enter amount"),
      account: Yup.object().required("Please Pilih Akun").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
      company: Yup.object().required("Please Select Company").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getTransactionTaxLoading());
      if (isEdit) {
        const updateTransactionTax = {
          id: transactionTax ? transactionTax.id : 0,
          name: values.name,
          code: values.code,
          amount: values.amount,
          accId: values.account.value,
          description: values.description,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onUpdateTransactionTax(updateTransactionTax));
        validation.resetForm();
      } else {
        const newTransactionTax = {
          name: values.name,
          code: values.code,
          amount: values.amount,
          accId: values.account.value,
          description: values.description,
          companyId: values.company.value,
          clientId: values.client.value,
        };
        dispatch(onAddNewTransactionTax(newTransactionTax));
        validation.resetForm();
      }
      toggle();
    },
  });

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteTransactionTax(element.value));
    });
    checkall.checked = false;
  };

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = transactionTaxList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setTransactionTaxList(updated);
    setIsCheckAll(allChecked);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = transactionTaxList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setTransactionTaxList(updatedData);
                }}
              />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateTransactionTax") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      handleTransactionTaxClick(data);
                    }}
                  >
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteTransactionTax") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      onClickDelete(data);
                    }}
                  >
                    <i className="ri-delete-bin-line fs-15 text-danger"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Nama Pajak",
        accessor: "name",
        filterable: true,
      },
      {
        Header: "Kode",
        accessor: "code",
        filterable: true,
      },
      {
        Header: "%",
        accessor: "amount",
        filterable: true,
      },
      {
        Header: "Akun",
        accessor: "transaction_tax_acc_account.name",
        filterable: true,
        Cell: (cell) => {
          return (
            <span>
              {cell.row.original.transaction_tax_acc_account && cell.row.original.transaction_tax_acc_account.code} - {cell.row.original.transaction_tax_acc_account && cell.row.original.transaction_tax_acc_account.name}
            </span>
          );
        },
      },
      {
        Header: "Keterangan",
        accessor: "description",
        filterable: true,
      },
      {
        Header: "Status",
        accessor: "transaction_tax_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "DRAFT":
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
            case "ACTIVE":
              return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
            case "INACTIVE":
              return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
            default:
              return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          }
        },
      },
    ],
    [transactionTaxList, handleTransactionTaxClick, userRole, userType, isCheckAll]
  );

  const [filterDate, setFilterDate] = useState(null);

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = transactionTaxList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setTransactionTaxList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => transactionTaxList, [transactionTaxList]);

  //TABLE
  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
    };
    dispatch(onGetTransactionTaxs(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setTransactionTaxList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    dispatch(resetTransactionTaxState());
    dispatch(onGetTransactionTaxs());
  };

  document.title = "Transaction Taxs | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={transactionTaxList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteTransactionTax} onCloseClick={() => setDeleteModal(false)} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Opsi Keuangan" pageTitle="Pajak" loading={loading}>
          <div className="flex-shrink-0">
            <button
              type="button"
              className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createTransactionTax") !== -1 ? "btn btn-primary add-btn me-2" : "btn btn-primary add-btn me-2 d-none"}
              id="create-btn"
              onClick={() => {
                setIsEdit(false);
                toggle();
              }}
            >
              <i className="ri-booklet-line me-1 align-bottom fs-14"></i> Tambah
            </button>
            <ExportDoc data={transactionTaxDoc} />
            {/* <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn ms-1 btn-soft-danger" : userRole && userRole.split(",").indexOf("deleteTransactionTax") !== -1 ? "btn ms-1 btn-soft-danger" : "btn ms-1 btn-soft-danger d-none"} onClick={() => setDeleteModalMulti(true)}>
              <i className="ri-delete-bin-5-line me-1 align-bottom fs-15"></i> Delete
            </button> */}
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card id="transactionTaxList">
              <CardBody className="pt-2">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-booklet-line me-1 align-bottom fs-14"></i> ALL TAX
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "2" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("2", "DRAFT");
                        }}
                        href="#"
                      >
                        <i className="ri-information-line me-1 align-bottom fs-14"></i> DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "3" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("3", "ACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> ACTIVE
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "4" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("4", "INACTIVE");
                        }}
                        href="#"
                      >
                        <i className="ri-indetaxinate-circle-line me-1 align-bottom fs-14"></i> INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={2}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={8}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex - 1);
                            previousPage();
                          }}
                          disabled={!canPreviousPage}
                        >
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button
                          className="btn btn-light"
                          onClick={() => {
                            setPageIdx(pageIndex + 1);
                            nextPage();
                          }}
                          disabled={!canNextPage}
                        >
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Transaction Tax" : "Add Transaction Tax"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="mb-3">
                            <Label htmlFor="client-field" className="form-label">
                              Grup Usaha&nbsp;
                              {clientLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="client"
                              value={validation.values.client}
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              placeholder="Pilih Grup Usaha"
                              onChange={(e) => {
                                dispatch(setClientSelect(e));
                                validation.setFieldValue("client", e);
                              }}
                              options={clientList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="company-field" className="form-label">
                              Perusahaan&nbsp;
                              {companyLoading && (
                                <Spinner color="primary" size="sm">
                                  Loading...
                                </Spinner>
                              )}
                            </Label>
                            <Select
                              name="company"
                              value={validation.values.company}
                              placeholder="Pilih Perusahaan"
                              isDisabled={userType === "admin" || userType === "client" ? false : true}
                              onChange={(e) => {
                                dispatch(setCompanySelect(e));
                                validation.setFieldValue("company", e);
                              }}
                              options={companyList}
                            ></Select>
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="name-field" className="form-label">
                              Nama
                            </Label>
                            <Input name="name" id="name-field" className="form-control" placeholder="Isi Nama" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name} invalid={validation.touched.name && validation.errors.name ? true : false} />
                            {validation.touched.name && validation.errors.name ? <FormFeedback type="invalid">{validation.errors.name}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="code-field" className="form-label">
                              Kode
                            </Label>
                            <Input name="code" id="code-field" className="form-control" placeholder="Isi Kode" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code} invalid={validation.touched.code && validation.errors.code ? true : false} />
                            {validation.touched.code && validation.errors.code ? <FormFeedback type="invalid">{validation.errors.code}</FormFeedback> : null}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="amount-field" className="form-label">
                              Pajak %
                            </Label>
                            <Input name="amount" id="amount-field" className="form-control" placeholder="Isi Pajak" type="text" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.amount} invalid={validation.touched.amount && validation.errors.amount ? true : false} />
                            {validation.touched.amount && validation.errors.amount ? <FormFeedback type="invalid">{validation.errors.amount}</FormFeedback> : null}
                          </div>

                          <div className="mb-3">
                            <label className="form-label" htmlFor="account">
                              Akun Pajak
                            </label>
                            <Select
                              name="account"
                              value={validation.values.account}
                              placeholder="Pilih Akun"
                              onChange={(e) => {
                                validation.setFieldValue("account", e);
                              }}
                              options={accountingList}
                            ></Select>
                            {validation.touched.account && validation.errors.account && (
                              <small className="text-danger" type="invalid">
                                {validation.errors.account}
                              </small>
                            )}
                          </div>
                          <div className="mb-3">
                            <Label htmlFor="des-field" className="form-label">
                              Keterangan
                            </Label>
                            <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                          </div>
                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                          }}
                        >
                          Tutup
                        </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">{!!isEdit ? "Update" : "Tambah Transaksi Pajak"}</span>
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TransactionTax;
